import moment from 'moment-timezone';

export default {
  operation: {
    stamped: false,
    owner: null,
    employeeId: null,
    ownerCompany: null,
    status: null,
    name: '',
    email: '',
  },
  type: 'O',
  paymentDate: moment(new Date()).unix(),
  paymentPeriodStart: moment(new Date()).unix(),
  paymentPeriodEnd: moment(new Date()).unix(),
  earnedDays: '',
  percepts: [{
    id: 0,
    perceptType: null,
    key: null,
    concept: null,
    taxedAmount: null,
    exemptAmount: null,
    overtime: [],
  }],
  deductions: [],
  otherPayments: [],
  paidLeaves: [],
};
